import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Row,
  Col,
  Form,
  Label,
  Input,
  FormFeedback,
  Button,
  Popover,
  PopoverBody,
} from "reactstrap";
// import images
import lightlogo from "../../assets/images/cashinvoice-white-logo.svg";
import verificationImg from "../../assets/images/5024147-Photoroom.png";
import colorlogo from "../../assets/images/ci_logo.png";
import "assets/scss/custom/pages/_signup.scss";
import { useAsyncDebounce } from "react-table";
import { callGetPanDetails } from "http/gstin/gstin";
import { callUserSignUp } from "http/auth/signup";
import ToastDialog from "components/Common/ToastDialog";
import API_SERVICES from "constants/app.constants";
import CryptoJS from "crypto-js";
import InputMask from "react-input-mask";

const CustomerSignUpVerify = () => {
  const navigate = useNavigate();

  const [popovertop, setPopovertop] = useState(false);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [visible, setVisible] = useState(false);
  const [isPanSerching, setIsPanSerching] = useState(false);
  const [constitution, setConstitution] = useState(null);
  const [isAgree, setIsAgree] = useState(false);

  document.title = "Register | FundLync";

  const onPanChange = useAsyncDebounce((value) => {
    if (!validation.errors.pan) findPanDetails(value);
  }, 400);

  //form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      email: "",
      phone: "",
      name: "",
      pan: "",
      companyName: "",
      constitution: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Must be a valid Email")
        .max(255)
        .required("Email is required"),
      phone: Yup.number().min(10).required("Please Enter Your Phone"),
      name: Yup.string().required("Please Enter Your Name"),
      password: Yup.string()
        .matches(API_SERVICES.PASSWORD_PATTERN, "Enter valid password pattern")
        .required("Password is required"),
      rePassword: Yup.string().when("password", {
        is: (val) => !!(val && val.length > 0),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          "Both password need to be the same"
        ),
      }),
      pan: Yup.string()
        .matches(API_SERVICES.PAN_PATTERN, "Enter correct PAN!")
        .required("Please Enter Your PAN"),
      companyName: Yup.string().required("Please Enter Comapany name"),
      constitution: Yup.string().required("Please Enter constitution"),
    }),
    onSubmit: (values) => {
      if (isAgree) {
        submitUserRegistration(values);
      } else {
        setToastInfo({
          message: "Accept Term and Condition",
          showToast: true,
          role: "error",
        });
        validation.setSubmitting(false);
      }
    },
  });

  const acceptAgreement = (event) => {
    setIsAgree(event.target.checked);
  };

  const submitUserRegistration = (values) => {
    const passphrase = process.env.REACT_APP_KEY;
    const encrypted = CryptoJS.AES.encrypt(
      values.password,
      passphrase
    ).toString();
    const encryptedRe = CryptoJS.AES.encrypt(
      values.rePassword,
      passphrase
    ).toString();

    const postParams = {
      entityName: values.companyName,
      entityType: "Customer",
      pan: values.pan,
      entityConstitution: constitution || values.constitution,
      firstName: values.name,
      lastName: values.name,
      mobileNo: values.phone ? String(values.phone) : "",
      email: values.email,
      roleId: "2",
      password: encrypted,
      repassword: encryptedRe,
    };
    callUserSignUp(postParams)
      .then((result) => {
        if (result.code == 201 && result.status) {
          const { data } = result;
          setToastInfo({
            message: "Signup successfully",
            showToast: true,
            role: "success",
          });
          navigate({
            pathname: "/customer/register-otp-verify",
            search: `?email=${values.email}&entity=${data.entityId}`,
          });
        } else {
          const { message } = result;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((e) => {})
      .finally((f) => {
        validation.setSubmitting(false);
      });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      setVisible(!visible);
    }
  };

  const findPanDetails = (pan) => {
    setIsPanSerching(true);
    callGetPanDetails({ pan: pan })
      .then((result) => {
        if (result.code == 200 && result.status) {
          const { data: panDetails } = result;
          const { full_name, category, status } = panDetails;
          if (status === "VALID") {
            if (category === "Company") {
              setConstitution("Private Limited Company");
              validation.setFieldValue("companyName", full_name);
              validation.setFieldValue(
                "constitution",
                "Private Limited Company"
              );
            } else if (category === "Firm") {
              validation.setFieldValue("companyName", full_name);
              validation.setFieldValue("constitution", "Partnership");
            } else if (category === "Individual") {
              validation.setFieldValue("companyName", full_name);
              validation.setFieldValue("constitution", "Proprietorship");
            } else {
              validation.setFieldValue("companyName", full_name);
              validation.setFieldValue("constitution", category);
            }
          } else {
            validation.setFieldValue("companyName", "");
            validation.setFieldValue("constitution", "");
            setToastInfo({
              message: "Invalid PAN",
              showToast: true,
              role: "error",
            });
          }
        } else {
          setToastInfo({
            message: "Incorrect PAN",
            showToast: true,
            role: "error",
          });
          validation.setFieldValue("companyName", "");
          validation.setFieldValue("constitution", "");
        }
      })
      .catch((e) => {
        setToastInfo({
          message: "PAN not found",
          showToast: true,
          role: "error",
        });
        validation.setFieldValue("companyName", "");
        validation.setFieldValue("constitution", "");
      })
      .finally((f) => {
        setIsPanSerching(false);
      });
  };

  const handlePanChange = (value) => {
    value = value.toUpperCase();
    validation.setFieldValue("pan", value);
  };

  return (
    <React.Fragment>
      <div className="account-pages account-pages-bg bg-color login-page">
        <Row className="justify-content-center m-auto h-100vh scrollable-height" style={{width:'90%'}}>
          <Col  md={6} xl={8} lg={7} className="d-none d-md-block ">
            <div className="left-section h-100">
              <img src={lightlogo} alt="" className="img-fluid ci-logo"  style={{ width: '200px' }} />
              <div className="d-flex justify-content-center w-100 h-100 align-items-center">
                <img
                  src={verificationImg}
                  alt=""
                  className="img-fluid verification-img"
                />
              </div>
            </div>
          </Col>
          <Col md={6}
            lg={5}
            xl={4}
            className="form-layout-section m-auto d-flex justify-content-center ">
            <div className="d-flex flex-column h-100 vertical-scroll">
              <div className="p-2 mt-auto mb-auto">
                <div className="d-flex flex-column align-items-center">
                  <h3 className="mt-3 mb-3 header-reg">Registration</h3>
                </div>

                <Form
                  className="needs-validation"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <div className="form-floating mb-3">
                    <Input
                      name="name"
                      placeholder="Enter User Name"
                      type="text"
                      className="form-control"
                      id="validationUsername"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.name || ""}
                      invalid={
                        !!(validation.touched.name && validation.errors.name)
                      }
                      disabled={validation.isSubmitting}
                    />
                    <Label htmlFor="validationUsername">Name *</Label>
                    {validation.touched.name && validation.errors.name ? (
                      <FormFeedback type="invalid">
                        {validation.errors.name}
                      </FormFeedback>
                    ) : null}
                  </div>
                  <div className="form-floating mb-3">
                    <Input
                      name="email"
                      placeholder="Enter Valid Email"
                      type="email"
                      className="form-control"
                      id="validationEmail"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ""}
                      invalid={
                        !!(validation.touched.email && validation.errors.email)
                      }
                      disabled={validation.isSubmitting}
                    />
                    <Label htmlFor="validationEmail">Email *</Label>
                    {validation.touched.email && validation.errors.email ? (
                      <FormFeedback type="invalid">
                        {validation.errors.email}
                      </FormFeedback>
                    ) : null}
                  </div>
                  <div className="form-floating mb-3">
                    <Input
                      name="phone"
                      placeholder="Enter Contact Number"
                      type="number"
                      id="validationPhone"
                      className="form-control no-spin"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.phone || ""}
                      invalid={
                        !!(validation.touched.phone && validation.errors.phone)
                      }
                      disabled={validation.isSubmitting}
                    />
                    <Label htmlFor="validationPhone">Phone *</Label>
                    {validation.touched.phone && validation.errors.phone ? (
                      <FormFeedback type="invalid">
                        {validation.errors.phone}
                      </FormFeedback>
                    ) : null}
                  </div>
                  <div className="form-floating mb-3">
                    <div className="password-info">
                      <div className="form-floating">
                        <Input
                          style={{
                            backgroundImage: "none",
                          }}
                          name="password"
                          type={visible ? "text" : "password"}
                          placeholder="Password"
                          id="validationPassword"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          invalid={
                            !!(
                              validation.touched.password &&
                              validation.errors.password
                            )
                          }
                          disabled={validation.isSubmitting}
                        />
                        <Label htmlFor="validationPassword">Password *</Label>
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password ===
                            "Enter valid password pattern" ? (
                              <div style={{ marginLeft: "1rem" }}>
                                {validation.errors.password}
                              </div>
                            ) : (
                              validation.errors.password
                            )}
                          </FormFeedback>
                        ) : null}
                      </div>

                      {validation.touched.password &&
                      validation.errors.password ===
                        "Enter valid password pattern" ? (
                        <div
                          className="password-j"
                          id="passwordInfo"
                          onMouseOver={() => {
                            setPopovertop(!popovertop);
                          }}
                          onMouseOut={() => {
                            setPopovertop(!popovertop);
                          }}
                          onFocus={() => {
                            setPopovertop(true);
                          }}
                          onBlur={() => {
                            setPopovertop(false);
                          }}
                        >
                          <i
                            style={{ color: "#f46a6a" }}
                            className="mdi mdi-information-outline"
                          ></i>
                        </div>
                      ) : (
                        <div id="passwordInfo" />
                      )}

                      <div
                        onClick={() => setVisible(!visible)}
                        className="password-i"
                        id="passwordInfo"
                        onKeyDown={handleKeyDown}
                      >
                        {visible ? (
                          <i className="mdi mdi-eye"></i>
                        ) : (
                          <i className="mdi mdi-eye-off"></i>
                        )}
                      </div>
                    </div>

                    <Popover
                      className="password-dialog"
                      placement="left"
                      trigger="focus"
                      isOpen={popovertop}
                      target="passwordInfo"
                      toggle={() => {
                        setPopovertop(!popovertop);
                      }}
                    >
                      <PopoverBody>
                        <div className="d-flex flex-column">
                          <span className="title">Requirements</span>
                          <ul className="mt-2">
                            <li>Min. 8 Char. length</li>
                            <li>Min 1 lower-case</li>
                            <li>Min 1 upper-case</li>
                            <li>Min 1 special char(!,@,#,etc.)</li>
                            <li>Letter and numbers</li>
                          </ul>
                        </div>
                      </PopoverBody>
                    </Popover>
                  </div>
                  <div className="form-floating mb-3">
                    <Input
                      name="rePassword"
                      type="password"
                      placeholder="Re-type Password"
                      id="validationRePassword"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.rePassword || ""}
                      invalid={
                        !!(
                          validation.touched.rePassword &&
                          validation.errors.rePassword
                        )
                      }
                      disabled={validation.isSubmitting}
                    />
                    <Label htmlFor="validationRePassword">Re-Password</Label>
                    {validation.touched.rePassword &&
                    validation.errors.rePassword ? (
                      <FormFeedback type="invalid">
                        {validation.errors.rePassword}
                      </FormFeedback>
                    ) : null}
                  </div>
                  <div className="form-floating mb-3">
                    <div className="gstin-progress">
                      <div className="form-floating">
                        <InputMask
                          className={`form-control ${
                            validation.touched.pan && validation.errors.pan
                              ? "is-invalid"
                              : ""
                          }`}
                          mask={API_SERVICES.PAN_CHARACTER_NUMBER_FORMAT}
                          maskChar=""
                          alwaysShowMask={false}
                          name="pan"
                          placeholder="Enter PAN"
                          id="validationPan"
                          onChange={(e) => {
                            handlePanChange(e.target.value);
                            onPanChange(e.target.value);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.pan || ""}
                          invalid={
                            !!(validation.touched.pan && validation.errors.pan)
                          }
                          disabled={validation.isSubmitting || isPanSerching}
                        />
                        <Label htmlFor="validationPan">PAN *</Label>
                        {validation.touched.pan && validation.errors.pan ? (
                          <FormFeedback type="invalid">
                            {validation.errors.pan}
                          </FormFeedback>
                        ) : null}
                      </div>
                      {isPanSerching && (
                        <div
                          className="spinner-border progress-load"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      )}
                    </div>
                    {validation.touched.pan && validation.errors.pan ? (
                      <FormFeedback type="invalid">
                        {validation.errors.pan}
                      </FormFeedback>
                    ) : null}
                  </div>
                  {validation.values.companyName && (
                    <div className="form-floating mb-3">
                      <Input
                        name="companyName"
                        type="text"
                        placeholder="Enter Company Name"
                        id="validationCompanyName"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.companyName || ""}
                        invalid={
                          !!(
                            validation.touched.companyName &&
                            validation.errors.companyName
                          )
                        }
                        disabled
                      />
                      <Label htmlFor="validationCompanyName">
                        Company Name
                      </Label>
                    </div>
                  )}
                  {validation.values.constitution && (
                    <div className="form-floating mb-3">
                      <Input
                        name="constitution"
                        type="text"
                        placeholder="Company Constitution"
                        id="validationConstitution"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.constitution || ""}
                        invalid={
                          !!(
                            validation.touched.constitution &&
                            validation.errors.constitution
                          )
                        }
                        disabled
                      />
                      <Label htmlFor="validationConstitution">
                        Constitution
                      </Label>
                    </div>
                  )}
                  <div>
                    <Col lg="12">
                      <div className="form-check">
                        {isAgree}
                        <Input
                          type="checkbox"
                          className="form-check-input"
                          id="invalidCheck"
                          value={isAgree}
                          onChange={(event) => acceptAgreement(event)}
                          style={{ borderColor: "#ced4da" }}
                        />
                        <Label
                          className="form-check-label"
                          htmlFor="invalidCheck"
                        >
                          {" "}
                          Agree to{" "}
                          <span 
                            onClick={() =>
                              window.open(
                                "https://www.cashinvoice.in/legal/terms-and-conditions"
                              )
                            }
                            className="tandc"
                          >
                            terms and conditions
                          </span>
                        </Label>
                      </div>
                    </Col>
                  </div>
                  <div className="w-100 mt-3 d-flex justify-content-center">
                    <Button color="primary" type="submit">
                      <output>
                        {validation.isSubmitting && (
                          <span
                            className="spinner-border spinner-border-sm ms-2 me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                      </output>
                      {!validation.isSubmitting && <span>Submit</span>}
                      {validation.isSubmitting && <span>Submiting</span>}
                    </Button>
                  </div>
                </Form>
              </div>

              <div className="mt-2 text-center">
                <p>
                  Already have an account ?{" "}
                  <Link to="/login" className="fw-medium text-primary">
                    {" "}
                    Login
                  </Link>{" "}
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default CustomerSignUpVerify;
